import Provider from "../Provider";
import FetchSettings from "../../interfaces/FetchSettings";

export default class ApexProvider extends Provider {
  protected baseUrl = process.env.APEX_API_URL;

  public async hasAccess(): Promise<boolean> {
    const settings: FetchSettings = {
      method: "GET",
    };
    try {
      await this.request(this.baseUrl + "tools/ping", settings);
      return true;
    } catch (error) {
      return false;
    }
  }
}
